import React, { useEffect, useState } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import styles from './controls.module.css';

const SHIFT_MULTIPLIER = 10;

const clamp = (n, min = -Infinity, max = Infinity) => Math.min(max, Math.max(min, n));
// Keeps focus in the box while its step buttons are pressed.
const keepFocus = (event) => event.preventDefault();

/**
 * A compact number box with a trailing unit and ▴▾ buttons that step by `step` (ten steps with Shift). A typed
 * number applies on Enter or when the box is left; anything that is not a number snaps back.
 */
export const NumberField = ({ title, unit, value, step = 1, min, max, onChange, disabled = false }) => {
    const [draft, setDraft] = useState(String(value));
    useEffect(() => setDraft(String(value)), [value]);

    const commit = () => {
        const typed = Number.parseFloat(draft);
        if (Number.isFinite(typed)) onChange(clamp(Math.round(typed), min, max));
        else setDraft(String(value));
    };
    const nudge = (direction) => (event) => {
        onChange(clamp(value + direction * step * (event.shiftKey ? SHIFT_MULTIPLIER : 1), min, max));
    };

    return (
        <label className={`${styles.field} ${disabled ? styles.fieldDisabled : ''}`.trim()} title={title}>
            <input
                className={styles.fieldInput}
                inputMode="numeric"
                aria-label={title}
                disabled={disabled}
                value={draft}
                onChange={(event) => setDraft(event.target.value)}
                onBlur={commit}
                onKeyDown={(event) => event.key === 'Enter' && event.currentTarget.blur()}
            />
            {unit && <span className={styles.fieldUnit}>{unit}</span>}
            <span className={styles.stepper}>
                <button type="button" tabIndex={-1} aria-label={`Increase ${title}`} onMouseDown={keepFocus} onClick={nudge(1)}>
                    <KeyboardArrowUpIcon />
                </button>
                <button type="button" tabIndex={-1} aria-label={`Decrease ${title}`} onMouseDown={keepFocus} onClick={nudge(-1)}>
                    <KeyboardArrowDownIcon />
                </button>
            </span>
        </label>
    );
};
